import { useState, useEffect, useContext } from "react";
import "./common.scss";
import FormRendererContext from "../../services/context/FormRendererContext";
import { currentFormattedDateAndTime, trackEvent } from "../../utils/mixPanel";
import CustomTooltip from "./ToolTip";
import { isUrl } from "../../utils/generalUtils";

const renderDescription = (desc) => {
  if (isUrl(desc)) {
    return (
      <img
        src={desc}
        alt="Description"
        className="mt-1 rounded"
        style={{ maxHeight: "200px" }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.style.display = "none";
          e.target.parentNode.textContent = desc;
        }}
      />
    );
  }
  return <span>{desc}</span>;
};

const RadioSelector = ({ data, setAnswer, formValidation }) => {
  const [selectedOption, setSelectedOption] = useState(undefined);
  const [validForm, setFormValidation] = useState(formValidation);
  const { answerData, isJourneyReadOnly } = useContext(FormRendererContext);
  const isPillSelector = data?.usePillSelector === true;
  const isOptionDisabled = data?.disabled || isJourneyReadOnly || false;

  useEffect(() => {
    setFormValidation(formValidation);
    if (data?.answer && data?.answer?.value && data?.answer?.value !== "") {
      setSelectedOption(data.answer?.value);
      setFormValidation(true);
    } else {
      setSelectedOption(undefined); // Clear selection if no data
    }

    if (answerData?.[data?.key]) {
      setSelectedOption(answerData?.[data?.key]?.value);
    }
  }, [formValidation, data]);

  return (
    <div className=" w-full pb-2">
      <div className={`form-title pt-3 ${data?.customClass || ""}`}>
        {data?.label}
        {data?.validate?.required ? (
          <span className={!validForm ? "text-red-700" : ""}> * </span>
        ) : (
          <></>
        )}
        {data?.description && (
        <div className="text-[14px] text-[#616161] font-normal mt-1">
          {Array.isArray(data.description) ? (
            <div className="space-y-1">
              {data.description.map((item, index) => (
                <div key={index}>{renderDescription(item)}</div>
              ))}
            </div>
          ) : (
            renderDescription(data.description)
          )}
        </div>
      )}
        

        {data?.tooltip && (
          <div className="inline text-center px-1 ">
            <CustomTooltip
              tooltipText={data.tooltip}
              width="500px"
            ></CustomTooltip>
          </div>
        )}
      </div>
      {data?.values && data?.values?.length ? (
        <>
          {isPillSelector ? (
            <div className="radio-pill-group" role="radiogroup" aria-label={data?.label || data?.key}>
              {data.values.map((item) => {
                const isSelected = selectedOption === item.value;

                return (
                  <button
                    key={item.value}
                    type="button"
                    role="radio"
                    aria-checked={isSelected}
                    disabled={isOptionDisabled}
                    className={`radio-pill-option ${isSelected ? "selected" : ""}`}
                    onClick={() => {
                      if (isOptionDisabled) return;

                      setSelectedOption(item.value);
                      setAnswer(data, item);
                      setFormValidation(true);
                      trackEvent(`radio ${data?.label} clicked`, {
                        question: data?.label,
                        questionKey: data?.key,
                        clickedAt: currentFormattedDateAndTime(),
                        data: "Answered",
                      });
                    }}
                  >
                    {item.label}
                  </button>
                );
              })}
            </div>
          ) : (
            <div className="">
              {data.values.map((item) => {
                return (
                  <div
                    key={item.value}
                    className="radio-common custom-radio-selector my-3 "
                  >
                    <label className="pl-2">
                      <input
                        type="radio"
                        value={item.value}
                        checked={selectedOption === item.value}
                        disabled={isOptionDisabled}
                        className="mr-2 custom-radio"
                        id="box-shadow"
                        onClick={() => {
                          if (isOptionDisabled) return;

                          setSelectedOption(item.value);
                          setAnswer(data, item);
                          setFormValidation(true);
                          trackEvent(`radio ${data?.label} clicked`, {
                            question: data?.label,
                            questionKey: data?.key,
                            clickedAt: currentFormattedDateAndTime(),
                            data: "Answered",
                            // selectedValue: item.label,
                          });
                        }}
                      />
                      <span className="form-subtitle">{item.label}</span>
                    </label>
                  </div>
                );
              })}
            </div>
          )}
        </>
      ) : (
        <div></div>
      )}
      {data?.validate?.required && !validForm ? (
        <span className="text-red-700 font-light text-xs">
          {" "}
          Required Field{" "}
        </span>
      ) : (
        <></>
      )}
    </div>
  );
};
export default RadioSelector;
